import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { selectOrderedDataIds } from 'services/timesheetTimesheetEntriesForm/selectors';

// Components
import SelectedTableCellRowCheckbox from '../../../../../../../../components/SelectedTableCellRowCheckbox';

interface Props {
    ids: number[];
}

export class TimesheetTimesheetEntriesTableHeadCheckbox extends React.PureComponent<Props> {
    render() {
        const { ids } = this.props;
        return <SelectedTableCellRowCheckbox rowId={ids} />;
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectOrderedDataIds
});

export default connect(mapStateToProps)(
    TimesheetTimesheetEntriesTableHeadCheckbox
);
